/*
 * IMPORTS
 */
import { gql } from '@apollo/client'

/*
 * EXPORTS
 */
export default gql`
  query LCRRouteReadQuery($routeId: ID!) {
    LCRRouteRead(routeId: $routeId) {
      id
      displayName
      type
      CustomerAccount {
        id
        displayName
      }
    }
  }
`
